export interface TravelTicketRoute {
  from: string;
  to: string | null;
  via: string | null;
}
